import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#14464F',
      light: '#3C8178',
      dark: '#07232D',
    },
    secondary: {
      main: '#F2C143',
    },
    background: {
      /* Aligns with index.html + ModernLoadingScreen hero — avoids gray flash after CssBaseline on hard navigations */
      default: '#041f24',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#07232D',
      secondary: '#14464F',
    },
    action: {
      active: '#3C8178',
      hover: '#F2C143',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
        containedPrimary: {
          backgroundColor: '#14464F',
          '&:hover': {
            backgroundColor: '#3C8178',
          },
        },
        containedSecondary: {
          backgroundColor: '#F2C143',
          color: '#07232D',
          '&:hover': {
            backgroundColor: '#E0E6E2',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#07232D',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#E0E6E2',
        },
      },
    },
  },
});

export default theme;